<template>
  <div class="cancelActive">
      <el-dialog :visible.sync="activeStatus" :before-close="cancel" title="取消提示" width="580px">
            <div class="title">
                <img src="./../../../common/images/activeOperate/icon-cancel.png" alt="calcel">
                <p class="red">取消活动后该活动将不能继续报名，报名成功的用户订单将自动取消。</p>
                <p>活动取消过程中产生的手续费将由主办方承担</p>
            </div>
            <div class="content">
                <p>账户余额: ¥ {{info.allbalance}} <span @click="balance">去充值></span></p>
                <p>您本次要取消的活动：{{info.title}} </p>
                <p class="red">手续费：¥{{info.totalpoundage}}</p>
            </div>
            <span class="btnlist">
                <el-button @click="cancel">取消</el-button>
                <el-button @click="submit" type="primary">确定</el-button>
            </span>
      </el-dialog>
  </div>
</template>

<script>
import {getCancelEnrolleventinfo, cancelEventinfoByHost} from 'api/activeApi'
import { mapActions} from 'vuex' // 引入 vuex 组件
export default {
    name: 'cancelActive',
    props: ['eventinnerid'],
    data() {
        return {
            activeStatus: false, // 弹窗状态
            info: {},   // 详情
        }
    },
    mounted() {},
    methods: {
        open() {    // 开启弹窗
            this.setLoading(true)
            // 获取余额详情
            getCancelEnrolleventinfo({
                data: {eventinnerid: this.eventinnerid},
                success: data => {

                    this.setLoading(false)
                    //  详情渲染
                    this.info = data.data
                    this.activeStatus = true
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
            
        },  
        cancel() {  // 关闭弹窗
            this.activeStatus = false
        },
        balance () {    // 充值
            let newurl = this.$router.resolve({
                name: 'Balance'
            })
            window.open(newurl.href, '_blank')
        },
        submit() {  // 确定取消

            cancelEventinfoByHost({
                data: {eventinnerid: this.eventinnerid},
                success: data => {

                    this.setLoading(false)
                    this.$message.success('操作成功')
                    
                    this.$emit('cancelDialogActive', true)
                    this.cancel()

                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })

        },
        ...mapActions(['setLoading'])
    }
}
</script>

<style lang="scss" type="text/scss">
.cancelActive {
    .title {
        img {
            display: block;
            margin: auto;
            margin-bottom: 13px;
            width: 44px;
            height: 44px;
            border-radius: 50%;
        }
        p {
            margin-bottom: 9px;
            text-align: center;
            color: #666;
        }
    }
    .red {
        font-size: 16px;
        color: #F56C6C !important;
    }
    .content {
        margin: auto 30px;
        margin-top: 30px;

        p {
            margin-bottom: 13px;
            color: #666;
            font-size: 14px;
            line-height: 20px;

            span {
                margin-left: 14px;
                color: #409EFF;
                cursor: pointer;
            }
        }
    }
    .btnlist {
        display: block;
        margin-top: 30px;
        width: 100%;
        text-align: center;

        .el-button {
            margin: auto 10px;
        }
    }
}
</style>